
import { createRouter,createWebHistory } from "vue-router";
import AppShell from '@/pages/wrapper/AppShell.vue';
 import Homepage from '@/pages/homepage/Homepage.vue';
 import Login from '@/pages/login/Login.vue';
 import ForbiddenAccess from '@/pages/server_responses/ForbiddenAccess.vue';
 import PageNotFound from '@/pages/server_responses/PageNotFound.vue';
 import Initialization from '@/pages/initialization/Initialization.vue';
 import Stocks from '@/pages/stocks/Stocks.vue';
 import Products from '@/pages/products/Products.vue';
 import OptionTags from '@/pages/optiontags/OptionTags.vue';
 import PaymentMethods from '@/pages/payment_method/PaymentMethods.vue';
 import Bank from '@/pages/bank/Bank.vue';
 import Banking from '@/pages/banking/Banking.vue';
 import PromotionalSMS from '@/pages/promotional_sms/PromotionalSMS.vue';
 import Users from '@/pages/users/Users.vue';
 import Branches from '@/pages/branches/Branches.vue';
 import ChartOfAccounts from '@/pages/chartofaccounts/ChartOfAccounts.vue';
 import SaleServices from '@/pages/saleservices/SaleServices.vue';
 import PrinterSetups from '@/pages/printersetups/PrinterSetups.vue';
 import ReceiptPrinters from '@/pages/receiptprinter/ReceiptPrinters.vue';
 import RequestedItems from '@/pages/requesteditem/RequestedItems.vue';
 import Profilers from '@/pages/profilers/Profilers.vue';
 import PosReceipt from '@/pages/pos_receipt/PosReceipt.vue';
 import PosReceiptRefund from '@/pages/pos_receipt_refund/PosReceiptRefund.vue';
 import Installation from '@/pages/Installation/Installation.vue';
 import JournalVoucher from '@/pages/journal_voucher/JournalVoucher.vue';
 import OtherVoucher from '@/pages/other_voucher/OtherVoucher.vue';
 import UserBalance from '@/pages/user_balance/UserBalance.vue';
 import ImportStock from '@/pages/import_stock/ImportStock.vue';
 import OpenHead from '@/pages/open_head/OpenHead.vue';
 import Invoice from '@/pages/invoice/Invoice.vue';
 import SalesReceipt from '@/pages/sales_receipt/SalesReceipt.vue';
 import PosPurchase from '@/pages/pos_purchase/PosPurchase.vue';
 import PosPurchaseReturn from '@/pages/pos_purchase_return/PosPurchaseReturn.vue';
 import { useStore, ActionTypes } from "./store";
 import EReceipt from '@/pages/e_receipt/EReceipt.vue';
 import AppCheckoutShell from '@/pages/wrapper/AppCheckoutShell.vue';
 import TransactionReceipt from '@/pages/transaction/TransactionReceipt.vue';
 import Privileges from '@/pages/privileges/Privileges.vue';
 import Report from '@/pages/reports/Report.vue';
 import SalesRefundReport from '@/pages/reports/SalesRefundReport.vue';
 import SalesReport from '@/pages/reports/SalesReport.vue';
 import TransferReport from '@/pages/reports/TransferReport.vue';
 import PurchasingReport from '@/pages/reports/PurchasingReport.vue';
 import PurchaseReturnReport from '@/pages/reports/PurchaseReturnReport.vue';
 import PerformanceReport from '@/pages/reports/PerformanceReport.vue';
 import GeneralJournal from '@/pages/reports/GeneralJournal.vue';
 import IncomeStatement from '@/pages/reports/IncomeStatement.vue';
 import TrialBalance from '@/pages/reports/TrialBalance.vue';
 import LedgerStatement from '@/pages/reports/LedgerStatement.vue';
 import TaxReport from '@/pages/reports/TaxReport.vue';
 import BankReconciliation from '@/pages/reports/BankReconciliation.vue';
 import AccountStatement from '@/pages/reports/AccountStatement.vue';
 import SmsSettings from '@/pages/sms_settings/SmsSettings.vue';
 import UsersReport from '@/pages/reports/UsersReport.vue';
 import StockReport from '@/pages/reports/StockReport.vue';
 import ActivityReport from '@/pages/reports/ActivityReport.vue';
 import StockExpiryReport from '@/pages/reports/StockExpiryReport.vue';
 import StockNearExpiryReport from '@/pages/reports/StockNearExpiryReport.vue';
 import StockAlertReport from '@/pages/reports/StockAlertReport.vue';
import CashierSessionLogin from '@/pages/cashier_session/CashierSessionLogin.vue';
import CashierSessionLogout from '@/pages/cashier_session/CashierSessionLogout.vue';
import CashierSessionView from '@/pages/cashier_session/CashierSessionView.vue';
import CashierSession from "./service/CashierSession";
import Logout from '@/pages/login/Logout.vue';
import PosService from "./service/PosService.js";
import VueTest from "./components/VueTest.vue";
import AppShellNoLoading from "@/pages/wrapper/AppShellNoLoading.vue";
import Suppliers from "@/pages/profilers/Suppliers.vue";
 //import Configurations from '@/pages/configurations/Configurations.vue';


const ifAuthenticated = (to, __, next) => {
  
  try {
    const u = userPermission(to.meta.permission);


    const store = useStore();
    if (store.getters.isAuthenticated == '') next({ path: '/login' })
    else if (u == false)
    {
      next({ path: '/forbidden' })
    }
    else
    {
      next();
      document.title = to.name;
    }
  } catch (e) {
    console.error('Invalid JSON in localStorage', e);
  }
}

const ifHasCashierSession = (to, __, next) => {
  const u = userPermission(to.meta.permission);
  const store = useStore();
  if (store.getters.isAuthenticated == '') next({ path: '/login' })
  else if (u == false)
  {
    next({ path: '/forbidden' })
  }
  else
  {
    const now = new Date();
    const cashierSessionUpdatedAt = new Date(store.getters.getCashierSession);
    const consideredOldTime = new Date(now.getTime() - 1 * 60 * 1000);// configured to 1 min now

    if(store.getters.getCashierSession != ''){

      if(consideredOldTime.getTime() < cashierSessionUpdatedAt.getTime()) { // Not over 1 min after cashierSessionUpdatedAt 
          next();
          document.title = to.name;
      } else { // over considered time (Ex: over 1 mins)
            //console.log('timeout request : oldTIme' + consideredOldTime.getTime() + '| updatedTime:' +cashierSessionUpdatedAt.getTime());
          // session is older than considered minutes ago, need to call API
          const cashierService = new CashierSession();
          cashierService.keepAliveCashierSession()
          .then((res) => {
            if(res.status_id == 1){
              store.dispatch(ActionTypes.CASHIER_SESSION, Date());
              next();
              document.title = to.name;
            } else {
              store.dispatch(ActionTypes.CASHIER_SESSION, "");
              next({ path: '/cashier/start-cashier-session' });
            }
          });

      }

    } else { // No cashier session
            
      //console.log('no key saved');
        // session is older than considered minutes ago, need to call API
        const cashierService = new CashierSession();
        cashierService.keepAliveCashierSession()
        .then((res) => {
          if(res.status_id == 1){
            store.dispatch(ActionTypes.CASHIER_SESSION, Date());
            next();
            document.title = to.name;
          } else {
            store.dispatch(ActionTypes.CASHIER_SESSION, "");
            next({ path: '/cashier/start-cashier-session' });
          }
        });

    }
  }
}


const ifNotAuthenticated = (_, __, next) => {

  const store = useStore();
  if (store.getters.isAuthenticated == '') { 
    next();
    document.title = _.name;
  }
  else next({ path: '/home/dashboard' })

}

const routes = [
  { path: '/', redirect: "/login", beforeEnter: ifAuthenticated },
  { path: '/logout', name: 'logout',  meta: {permission:'logout'}, component: Logout},
  { path: '/login', name: 'login',  meta: {permission:'login'}, component: Login, beforeEnter: ifNotAuthenticated},
  { path: '/install', name: 'install',  meta: {permission:'install'}, component: Installation},
  { path: '/forbidden', name: 'forbidden',  meta: {permission:'forbidden'}, component: ForbiddenAccess },
  { path: '/pos', name: 'Orders', meta: {permission:'orders'}, component: PosReceipt, beforeEnter: ifHasCashierSession},
  { path: '/pos-refund', name: 'Order Refund',  meta: {permission:'order_refund'}, component: PosReceiptRefund, beforeEnter: ifHasCashierSession},
  { path: '/purchasing', name: 'Purchasing',  meta: {permission:'purchasing'}, component: PosPurchase, beforeEnter: ifAuthenticated},
  { path: '/purchase-return', name: 'Purchase Returns',  meta: {permission:'purchasing'}, component: PosPurchaseReturn, beforeEnter: ifAuthenticated},
  { path: '/receipt/:randomPath', name: 'E Receipt',  meta: {permission:'e_receipt'}, component: EReceipt },
  {
    path: '/cashier',
    name: 'app_cashier',
    component: AppShell,
    beforeEnter: ifAuthenticated,
    children: [
      { path: 'start-cashier-session', name: 'Start Cashier Session', meta: {permission:'start_cashier_session'}, component: CashierSessionLogin},
      { path: 'end-cashier-session', name: 'Cashier Session', meta: {permission:'start_cashier_session'}, component: CashierSessionLogout},
      { path: 'cashier-session', name: 'View Cashier Session', meta: {permission:'view_cashier_session'}, component: CashierSessionView},
    ]
  },
  {
  path: '/home',
  name: 'Home', 
  component: AppShellNoLoading,
  beforeEnter: ifAuthenticated,
  children: [
    { path: 'dashboard', name: 'Dashboard', meta: {permission:'dashboard'}, component: Homepage },
    { path: 'suppliers', name: 'Suppliers', meta: {permission:'supplier_credit_page'}, component: Suppliers },
    ]
  },
  {
    path: '/process',
    name: 'Transaction Receipt', 
    meta: {permission:'transaction_receipt'},
    component: AppCheckoutShell,
    beforeEnter: ifAuthenticated,
    children: [
        { path: 'transactions', name: 'Transaction Receipt', meta: {permission:'transaction_receipt'}, component: TransactionReceipt },
      ]
  },
  {
    path: '/store',
    name: 'app_shell_main',
    component: AppShell,
    beforeEnter: ifAuthenticated,
    children: [
      { path: 'initialization', name: 'Initialization', meta: {permission:'initialization'}, component: Initialization },
      { path: 'other-voucher', name: 'Other Voucher', meta: {permission:'other_voucher'}, component: OtherVoucher },
       { path: 'stores', name: 'Branches', meta: {permission:'branches'}, component: Branches },
       { path: 'banks', name: 'Banks', meta: {permission:'banks'}, component: Bank },
       { path: 'banking', name: 'Banking', meta: {permission:'banking'}, component: Banking },
       { path: 'sale-services', name: 'Sale Services', meta: {permission:'sale_services'}, component: SaleServices },
       { path: 'stocks', name: 'Stocks', meta: {permission:'stocks'}, component: Stocks },
       { path: 'products', name: 'Products', meta: {permission:'products'}, component: Products },
       { path: 'chart-of-accounts', name: 'Chart Of Accounts', meta: {permission:'chart_of_accounts'}, component: ChartOfAccounts },
       { path: 'option-tag', name: 'Option Tags', meta: {permission:'option_tags'}, component: OptionTags,beforeEnter: ifAuthenticated, },
       { path: 'payment-method', name: 'Payment Methods', meta: {permission:'payment_methods'}, component: PaymentMethods },
       { path: 'journal-voucher', name: 'Journal Voucher', meta: {permission:'journal_voucher'}, component: JournalVoucher },
       { path: 'import-stock', name: 'Import Stock', meta: {permission:'import_stock'}, component: ImportStock },
       { path: 'user-balance', name: 'User Balance', meta: {permission:'user_balance'}, component: UserBalance },
       { path: 'open-head', name: 'Open Head', meta: {permission:'open_head'}, component: OpenHead },
       { path: 'invoice', name: 'Invoice', meta: {permission:'invoice'}, component: Invoice },
       { path: 'sales-receipt', name: 'Sales/Refund Receipt', meta: {permission:'sales_receipt'}, component: SalesReceipt },
       { path: 'users', name: 'Users', meta: {permission:'users'}, component: Users },
       { path: 'privileges', name: 'Privileges', meta: {permission:'privileges'}, component: Privileges },
      { path: 'receipt-printer', name: 'Receipt Content', meta: {permission:'receipt_content'}, component: ReceiptPrinters},
      { path: 'sms-settings', name: 'Sms Settings', meta: {permission:'sms_settings'}, component: SmsSettings},
      { path: 'printer-setup', name: 'Printer Setup', meta: {permission:'printer_setup'}, component: PrinterSetups},
      { path: 'requested-items', name: 'Requested Items', meta: {permission:'requested_items'}, component: RequestedItems},
       { path: 'profilers', name: 'Profilers', meta: {permission:'profilers'}, component: Profilers },
       { path: 'promotional-sms', name: 'Promotional SMS', meta: {permission:'promotional_sms'}, component: PromotionalSMS },
    ]
  },
  {
    path: '/report',
    name: 'app_shell',
    meta: {permission:'report'},
    component: AppShell,
    beforeEnter: ifAuthenticated,
    children: [ 
       { path: 'index', name: 'Report', meta: {permission:'report'}, component: Report },
// DASHBOARD
       { path: 'stock-alert-report', name: 'Stock Alert Report', meta: {permission:'stock_alert_report'}, component: StockAlertReport },
       { path: 'near-expiry-report', name: 'Near Expiry Report', meta: {permission:'stock_near_expiry_report'}, component: StockNearExpiryReport },
       { path: 'expiry-report', name: 'Expired Products Report', meta: {permission:'stock_expiry_report'}, component: StockExpiryReport },
 // Reports Page
       { path: 'sales-report', name: 'Sales Report', meta: {permission:'sales_report'}, component: SalesReport },
       { path: 'sales-refund-report', name: 'Sales/Refund Report', meta: {permission:'sales_refund_report'}, component: SalesRefundReport },
       { path: 'purchasing-report', name: 'Purchase Report', meta: {permission:'purchasing_report'}, component: PurchasingReport },
       { path: 'purchase-return-report', name: 'Purchase-Return Report', meta: {permission:'purchase_returns_report'}, component: PurchaseReturnReport},
       { path: 'transfer-reports', name: 'Transfer Report', meta: {permission:'transfer_report'}, component: TransferReport },
       { path: 'performance-report', name: 'Performance Report', meta: {permission:'performance_report'}, component: PerformanceReport },
       { path: 'general-journal-report', name: 'General Journal', meta: {permission:'general_journal'}, component: GeneralJournal },
       { path: 'income-statement-report', name: 'Income Statement', meta: {permission:'income_statement'}, component: IncomeStatement },
       { path: 'user-report', name: 'User Report', meta: {permission:'user_report'}, component: UsersReport },
      //  { path: 'trial-balance-report', name: 'Trial Balance', meta: {permission:''}, component: TrialBalance },
      //  { path: 'ledger-statement', name: 'Ledger Statement', meta: {permission:''}, component: LedgerStatement },
      //  { path: 'tax-report', name: 'Tax Report', meta: {permission:''}, component: TaxReport },
      //  { path: 'bank-reconciliation', name: 'Bank Reconciliation', meta: {permission:''}, component: BankReconciliation },
      //  { path: 'account-statement', name: 'Account Statement', meta: {permission:''}, component: AccountStatement },
      //  { path: 'stock-report', name: 'StockReport', meta: {permission:''}, component: StockReport },
      //  { path: 'activity-report', name: 'Activity Report', meta: {permission:''}, component: ActivityReport },
      //  { path: 'expiry-report', name: 'Expired Products Report', meta: {permission:''}, component: StockExpiryReport },
       //{ path: 'configurations', name: 'Configurations', meta: {permission:''}, component: Configurations },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page Not Found',  
    component: PageNotFound 
  },
]



const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log('Navigating from', from, 'to', to.path);
  var notAllowed = false;
  // if((from.path == '/' && to.path == '/pos') || (from.path == '/' && to.path == '/purchasing')){  // Refresh
  //   notAllowed = true;
  // } else 
  if(from.path == '/pos') { // From POS
    notAllowed = true;
  } else if(from.path == '/pos-refund') { // From POS Refund
    notAllowed = true;
  } else if(from.path == '/purchasing') { // From Purchase
    notAllowed = true;
  } else if(from.path == '/purchase-return') { // From Purchase
    notAllowed = true;
  }

  var pur_item_list = localStorage.getItem('pur_items');
  var pos_item_list = localStorage.getItem('pos_items');

  if(notAllowed && (pur_item_list == '1' || pos_item_list == '1')){
    const answer = window.confirm("Do you want to leave? If you leave, your unsaved data will be lost. Continue?");
    if (answer) {
      next(); // Allow navigation
    } else {
      next(false); // Cancel navigation
    }
  }
  
  next();
});

const userPermission = (user_permission) => {
  const store = useStore();

  try {
    const pL =  JSON.parse(store.getters.gerUserPermissions);
    const f = pL.filter(e =>  e.name == user_permission);
  // //console.log(pL);
    let res = false;
  
      if(f.length > 0)
      {
        res = true;
      }
  
      return res;
  } catch (e) {
    console.error('Invalid JSON in localStorage', e);
  }
}


// const router = createRouter({
//   history: createWebHistory(''),
//   routes,
// });

export default router;